module.exports = __webpack_public_path__ + "static/media/umbrella.287cb5c7.svg";